import { useTierContext } from '../TierProvider';

export const useRemainingClassesQuota = () => {
  const { tier } = useTierContext();

  const quotaDifference = tier.numLimitedClassesTotal - tier.numLimitedClassesTaken;
  return quotaDifference < 0 ? 0 : quotaDifference;
};
